import * as moment from 'moment-timezone';
import { padStart } from 'src/util/string';

export function getDuration(start: Date, end: Date): moment.Duration {
  const startMoment = moment(start);
  const endMoment = moment(end);
  const duration = moment.duration(endMoment.diff(startMoment));
  return duration;
}

type DurationFormat = 'HH:mm' | 'DD:HH:mm';
export function formatDuration(duration: moment.Duration, format: DurationFormat): string {
  const formatTime = (num: number) => padStart(Math.floor(num).toString(), 2, '0');
  switch (format) {
    case 'HH:mm': {
      const hourDisplay = formatTime(duration.asHours());
      const minuteDisplay = formatTime(duration.minutes());
      return `${hourDisplay}:${minuteDisplay}`;
    }
    case 'DD:HH:mm': {
      const dayDisplay = formatTime(duration.asDays());
      const hourDisplay = formatTime(duration.hours());
      const minuteDisplay = formatTime(duration.minutes());

      return `${dayDisplay}:${hourDisplay}:${minuteDisplay}`;
    }
  }
}
